import { useQuery } from '@tanstack/react-query';
import { useDashboardIdentity } from './useDashboardIdentity';
import { salesGet, type SalesSelf, type SalesSummary } from '@/lib/salesTeam';

export function useSalesSelf(enabled = true) {
  const identity = useDashboardIdentity();
  return useQuery({ queryKey: ['sales-self', identity], enabled,
    queryFn: () => salesGet<SalesSelf>('admin/sales-book/me'), staleTime: 0,
    refetchInterval: 30_000, refetchOnWindowFocus: true });
}

export function useSalesBookSummary(enabled = true) {
  const identity = useDashboardIdentity();
  return useQuery({ queryKey: ['sales-summary', identity], enabled,
    queryFn: () => salesGet<SalesSummary>('admin/sales-book/summary'),
    staleTime: 0, refetchInterval: 15_000 });
}
